import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';

const DELETE_PAYSLIP = gql`
  mutation DeletePayslip($uuid: ID!) {
    deletePayslip(deletedPayslip: { uuid: $uuid })
  }
`;

export const useDeletePayslip = () => {
  const [deletePayslip, { loading, error, data }] = useMutation(DELETE_PAYSLIP);
//   console.log("useDeletePayslip", deletePayslip);

  return { deletePayslip, loading, error, data };
};
